/* ----------mst guide modal------------------*/

$(document).ready(function(){
  $('.tooltip, .tooltiptext').hide();
   
    $(".close").click(function() {
        $(".modal_guide").fadeOut(150);
        $("body").css("overflow","scroll");
    });
    
      $('body').click(function(e) {
        if ($(e.target).closest('.product-single').length){  // click anywhere tooltip close
            $(".tooltip").fadeOut(150);
        }
    });
    $('.checkWeight').click(function(e) {
        e.stopPropagation();  // when click on checkWeight btn thats not close
    });

  
    function calculateX(weight) {
            var x;
            switch (true) {
              case (weight >= 1 && weight <= 10):
                x = 1;
                break;
              case (weight > 10 && weight <= 20):
                x = 2;
                break;
              case (weight > 20 && weight <= 30):
                x = 3;
                break;
              case (weight > 30):
                x = 4;
                break;
              default:
                x = 'Invalid';
            }
            return x;
          }
     
        // $(".validation").hide();
         $('.checkWeight').click(function() {
          var weight = $('#weight').val().replace(",",".");
          var x = calculateX(weight);
          $('.valueOfX').text(' ' + x + ' ');
          $('#valid-weight').show();
          $('#invalid-weight').hide();
         
           if(x == 1){
              $('.boxes').text(' ' + 'Boîte' + ' ' );
              $('.friandise').text(' ' + 'Friandise' + ' ' );
              $('.assure').text(' ' + 'assure' + ' ' );
             
            }else{
               $('.boxes').text(' ' + 'Boîtes' + ' ' );
               $('.friandise').text(' ' + 'Friandises' + ' ' );
               $('.assure').text(' ' + 'assurent' + ' ' );
           }

          if(x == 'Invalid'){
            $('#valid-weight').hide();
            $('#invalid-weight').show();
          }
         
          $('.tooltip, .tooltiptext').css("display","block");
       });
});
/* ----------endmst guide modal------------------*/